import { useMemo } from 'react';
import PendingApprovalButton from '../button/PendingApprovalButton';
import ApprovalButton from '../button/ApprovalButton';
import withErrorBoundary from '../../hoc/withErrorBoundary';
import RequestChangesButton from '../button/RequestChangesButton';
import { useHasReadWriteScope } from '../../hooks/useHasReadWriteScope';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { ApprovalDataLoadingSpinner } from '../common/ApprovalDataLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalButtons(props) {
  const {
    buttonProps = {},
    children = null,
    tooltipProps = {},
    hidePendingButton,
    onClickRequestChanges,
    requestChangesButtonProps = {},
    primaryButtonUse,
    secondaryButtonUse
  } = props;
  const approval = useApprovalContext();
  const {
    isFetchComplete,
    isDisabled,
    isApproved,
    isPending,
    isUserStepPending,
    isConcludedAndShouldRestartOnConclude
  } = useApprovalConditions();
  const showChildren = useMemo(() => {
    if (isDisabled) {
      return true;
    }
    if (isApproved && isConcludedAndShouldRestartOnConclude) {
      return false;
    }
    return isApproved;
  }, [isDisabled, isApproved, isConcludedAndShouldRestartOnConclude]);
  const showRequestChanges = useMemo(() => {
    return typeof onClickRequestChanges === 'function' && isPending && isUserStepPending && approval.config.approvalType !== 'QUOTE';
  }, [onClickRequestChanges, isUserStepPending, isPending, approval.config.approvalType]);
  const hasReadPermissions = useHasReadWriteScope(approval, 'read');
  const hasWritePermissions = useHasReadWriteScope(approval, 'write');
  if (!hasReadPermissions && !hasWritePermissions) {
    return null;
  }
  if (!isFetchComplete) {
    return /*#__PURE__*/_jsx(ApprovalDataLoadingSpinner, {});
  }
  if (showChildren) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: approval.meta.userCanSkipThisApproval && children
    }), approval.meta.availableOperations.map(operation => /*#__PURE__*/_createElement(ApprovalButton, Object.assign({}, buttonProps, {
      availableOperation: operation,
      disabled: !hasWritePermissions,
      key: operation,
      primaryButtonUse: primaryButtonUse,
      secondaryButtonUse: secondaryButtonUse
    }))), !hidePendingButton && /*#__PURE__*/_jsx(PendingApprovalButton, {
      buttonProps: buttonProps,
      tooltipProps: tooltipProps
    }), showRequestChanges && /*#__PURE__*/_jsx(RequestChangesButton, Object.assign({}, buttonProps, requestChangesButtonProps, {
      disabled: !hasWritePermissions,
      onClickRequestChanges: onClickRequestChanges,
      approvalType: approval.meta.approvalType
    }))]
  });
}
export default withErrorBoundary(ApprovalButtons, 'ApprovalButtons');